import { createSlice } from "@reduxjs/toolkit";
import { fetchUserMeetings } from "./courseThunk";

const initialState = {
  meetings: null,
  listLoading: false,
  error: null,
  success: null,
  errorMessage: "",
};

export const meetingsSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserMeetings.pending, (state) => {
      state.listLoading = true;
    });
    builder.addCase(fetchUserMeetings.fulfilled, (state, action) => {
      state.listLoading = false;
      state.error = false;
      state.success = true;
      state.meetings = action.payload;
    });
    builder.addCase(fetchUserMeetings.rejected, (state, action) => {
      state.listLoading = false;
      state.error = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default meetingsSlice.reducer;
